import React, { useEffect } from 'react';
import { GHL_SURVEY_EMBED_URL } from '../constants/ghl';
import { PHONE_DISPLAY, PHONE_TEL } from '../constants/brand';

type GhlSurveyEmbedProps = {
  /** Override the default survey URL from constants/ghl */
  src?: string;
  title?: string;
  minHeightClassName?: string;
};

export default function GhlSurveyEmbed({
  src = GHL_SURVEY_EMBED_URL,
  title = 'Quote survey',
  minHeightClassName = 'min-h-[36rem] sm:min-h-[42rem]',
}: GhlSurveyEmbedProps) {
  const hasEmbed = Boolean(src && src.trim());

  useEffect(() => {
    if (!hasEmbed) return;

    // GHL often ships an embed helper; load once if not already present.
    const existing = document.querySelector('script[data-ghl-form-embed]');
    if (existing) return;

    const script = document.createElement('script');
    script.src = 'https://link.msgsndr.com/js/form_embed.js';
    script.async = true;
    script.dataset.ghlFormEmbed = 'true';
    document.body.appendChild(script);
  }, [hasEmbed]);

  return (
    <div className={`overflow-hidden rounded-lg border border-black/10 bg-white shadow-sm ${minHeightClassName}`}>
      {hasEmbed ? (
        <iframe
          title={title}
          src={src}
          className={`h-full w-full border-0 ${minHeightClassName}`}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allow="clipboard-write"
        />
      ) : (
        <div className={`flex h-full flex-col items-center justify-center px-6 py-16 text-center ${minHeightClassName}`}>
          <div className="label-eyebrow">Quote questionnaire</div>
          <h2 className="font-serif text-2xl text-ink sm:text-3xl">A few quick questions</h2>
          <p className="mt-4 max-w-md text-ink/70">
            The estimate survey will load here once the GoHighLevel embed is connected. Your Epic Home Pros header and
            footer stay on this page.
          </p>
          <a href={`tel:${PHONE_TEL}`} className="btn-primary mt-8">
            Or call {PHONE_DISPLAY}
          </a>
        </div>
      )}
    </div>
  );
}
